import httpClient from "Api/httpClient";

const END_POINT = "/tanker_trucks";

const getTankerTrucks = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getTankerTruck = (truck_id) => {
    if (!truck_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + truck_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printTankerTruck = (truck_id) => {
    if (!truck_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?truck_id=" + truck_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createTankerTrucks = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateTankerTrucks = (payload, truck_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + truck_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteTankerTrucks = (truck_id) => {
    const DELETE_END_POINT = END_POINT + "/" + truck_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getTankerTrucks, getTankerTruck, printTankerTruck, createTankerTrucks, updateTankerTrucks, deleteTankerTrucks };
